import premiumShopGiftUpdate from 'browse/premiumShop/premiumShopGiftUpdate';

const premiumShopWallet = wallet => {
	const body = document.querySelector('body');

	const handleToggleDetails = () => {
		if (body.clientWidth < 992) return;

		const details = wallet.querySelectorAll('.premium-shop-wallet__details');

		if (details) details.forEach(detail => detail.setAttribute('open', true));
	};

	handleToggleDetails();
	premiumShopGiftUpdate(wallet);
};

export default premiumShopWallet;
